import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";

const RELATIONSHIP_OPTIONS = [
  "Client",
  "Employee",
  "Vendor / Partner",
  "Member of the Public",
  "Other",
];

const CATEGORY_OPTIONS = [
  "Service Quality",
  "Billing / Payment",
  "Staff Conduct",
  "Data Privacy",
  "Other",
];

const GrievanceForm = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [relationship, setRelationship] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setFullName("");
    setEmail("");
    setPhoneNumber("");
    setRelationship("");
    setCategory("");
    setDescription("");
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const flowUrl = process.env.REACT_APP_GRIEVANCE_FLOW_URL;

    if (!flowUrl) {
      swal({
        title: "Grievance submission isn't configured yet.",
        text: "Please contact us directly at info@outcess.com in the meantime.",
        icon: "error",
        button: "Close",
      });
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        flowUrl,
        {
          fullName,
          email,
          phoneNumber,
          relationship,
          category,
          description,
          submittedAt: new Date().toISOString(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      swal({
        title: "Your grievance has been submitted successfully!",
        text: "Our team will review it and get back to you.",
        icon: "success",
        button: "Close",
      });

      resetForm();
    } catch (error) {
      swal({
        title: "We couldn't submit your grievance.",
        text: "Please try again or email us at info@outcess.com.",
        icon: "error",
        button: "Close",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="grievance-form-section">
      <form onSubmit={submitHandler}>
        <div className="grievance-grid">
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              required
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Nature of Grievance</label>
            <select
              required
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select grievance</option>

              {CATEGORY_OPTIONS.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Your relation to Outcess</label>
            <select
              required
              value={relationship}
              onChange={(e) => setRelationship(e.target.value)}
            >
              <option value="">Select relation</option>

              {RELATIONSHIP_OPTIONS.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group form-group-full">
            <label>Phone Number (Optional)</label>
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>

          <div className="form-group form-group-full">
            <label>Message</label>

            <textarea
              rows="6"
              required
              placeholder="Please describe your grievance details"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="grievance-submit-btn"
        >
          {loading ? "Submitting..." : "Submit Grievance"}
        </button>
      </form>
    </section>
  );
};

export default GrievanceForm;